import { Box, Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { AliasList } from '@/module/Dashboard/AliasList';
import { BibtexResearcherSync } from '@/module/Dashboard/BibtexResearcherSync';
import { ScopusResearcherSync } from '@/module/Dashboard/ScopusResearcherSync';
import { WosResearcherSync } from '@/module/Dashboard/WosResearcherSync';
import { ProfileDetails } from '@/module/Dashboard/model/DashboardTypes';

export interface DashboardProps {
  profileDetails: ProfileDetails;
}

export function Dashboard({ profileDetails }: DashboardProps) {
  const { t } = useTranslation();

  return (
    <Box p="lg">
      <Text
        mt="xl"
        fw="500"
        size="3xl"
      >
        {t('dashboard.welcome')}
      </Text>
      <Group mt="xl">
        <AliasList profileDetails={profileDetails} />
        <WosResearcherSync profileDetails={profileDetails} />
      </Group>
      <Group mt="xl">
        <BibtexResearcherSync />
        <ScopusResearcherSync profileDetails={profileDetails} />
      </Group>
    </Box>
  );
}
